import { render } from "./CustomerFormSearch.vue?vue&type=template&id=404af8b8&scoped=true"
import script from "./CustomerFormSearch.vue?vue&type=script&lang=js"
export * from "./CustomerFormSearch.vue?vue&type=script&lang=js"

import "./CustomerFormSearch.vue?vue&type=style&index=0&id=404af8b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404af8b8"]])

export default __exports__